import React, { Component } from 'react';
import { SnackbarProvider } from 'notistack';
import SvgIconSuccess from '../../static/icons/svgIconSuccess';
import SvgIconError from '../../static/icons/svgIconError';

import { MaterialDesignContent } from 'notistack';
import { styled } from '@mui/material/styles';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#1b2432 !important',
    color: '#fff',
    fontSize: '15px',
    padding: '13px 16px !important',
    minWidth: '375px !important',

    '> div': {
      padding: '0 !important',

      '> span': {
        fontWeight: '600 !important',
        fontSize: '15px !important',
      }
    },

    'svg': {
      marginRight: '16px !important',
      width: '26px',
      height: '26px',
    }
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#1b2432 !important',
    color: '#fff',
    fontSize: '15px',
    padding: '13px 16px !important',
    minWidth: '375px !important',

    '> div': {
      padding: '0 !important',

      '> span': {
        fontWeight: '600 !important',
        fontSize: '15px !important',
      }
    },

    'svg': {
      marginRight: '16px !important',
      width: '26px',
      height: '26px',
    }
  },
}));


const SnackBarWrapper = (props: any) => (
  <SnackbarProvider
    autoHideDuration={2000}
    Components={{
      success: StyledMaterialDesignContent,
      error: StyledMaterialDesignContent
    }}
    iconVariant={
      {
        error: (
          <SvgIconError
            width={24}
            height={24}
          />
        ),
        success: (
          <SvgIconSuccess
            width={24}
            height={24}
          />
        ),
      } as any
    }
    maxSnack={5}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
  >
    {props.children}
  </SnackbarProvider>
);

export default SnackBarWrapper;
